import Mapper from './Mapper';
import { FundsTransactionResponseDTO } from 'typings/dto/fundsTransaction';
import DIContainer from '../../services/DIContainer';
import { AutomaticFundsTransactionConditionType, FUNDS_TRANSACTION_GROUP } from '../../typings/models/fundsTransaction.enum';

export default class FundsTransactionMapper extends Mapper<FundsTransaction, FundsTransactionResponseDTO> {
  constructor(private subEntitiesMappers: DIContainer.SubEntitiesMappers) {
    super({
      name: 'name',
      technicalName: 'technicalName',
      tenant: 'tenant',
      type: 'type',
      usage: 'usage',
      calculationMethod: 'calculationMethod',
      settings: 'settings',
      group: 'group',
      groupSpecificSettings: 'groupSpecificSettings',
      counterpartyType: 'counterpartyType',
    });
  }

  public responseDTOToModel = (dto: FundsTransactionResponseDTO): FundsTransaction => {
    const outerMappers = this.getOuterMappers();
    const customFieldMapper = this.subEntitiesMappers.orderCustomField;
    const model = this.responseDTOToModelViaDiffMap(dto);
    if (model.group === FUNDS_TRANSACTION_GROUP.automatic) {
      model.groupSpecificSettings.conditions.forEach((condition, i) => {
        const dtoField = dto.groupSpecificSettings?.conditions[i].customField;
        if (condition.type === AutomaticFundsTransactionConditionType.orderCustomFieldValue && dtoField) {
          condition.customField = customFieldMapper.responseDTOToModel(dtoField, outerMappers);
        }
      });
    }

    return {
      ...model,
    };
  };
}
